import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { PersonSearch } from '@mui/icons-material';
import WeeklyStaffingRequirements from '../WeeklyStaffingRequirements';

const StaffingRequirementsSettings = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: { xs: 2, md: 4 }, mb: 4, px: { xs: 1, md: 3 } }}>
      <Box sx={{ mb: { xs: 2, md: 4 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <Box sx={{
            width: 48, height: 48, borderRadius: 2,
            background: 'linear-gradient(135deg, #008060 0%, #004c3f 100%)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(0, 128, 96, 0.3)',
          }}>
            <PersonSearch sx={{ color: '#fff', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
              Απαιτήσεις Προσωπικού
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Ρυθμίστε τις ανάγκες στελέχωσης ανά ημέρα και βάρδια
            </Typography>
          </Box>
        </Box>
      </Box>
      <WeeklyStaffingRequirements />
    </Container>
  );
};

export default StaffingRequirementsSettings;
